module.exports = __webpack_public_path__ + "d308073b/img/dollar-icon.35c9d638.svg";